import {connect} from 'react-redux';
import {getSelectedPudoAddress} from '../../../../../selectors/PudoSelectors';
import PudoSavedAddressText from '../../../../pudo/PudoSavedAddresses/PudoSavedAddressText';

export default connect(state => ({
  address: getSelectedPudoAddress(state),
  paddingLeft: false,
  contactNumber: state.address.deliveryAddressList.contactNumber,
}))(PudoSavedAddressText);
